import { render, staticRenderFns } from "./CourseCardMaterialsRequirements.vue?vue&type=template&id=b493e3da&scoped=true"
import script from "./CourseCardMaterialsRequirements.vue?vue&type=script&lang=js"
export * from "./CourseCardMaterialsRequirements.vue?vue&type=script&lang=js"
import style0 from "./CourseCardMaterialsRequirements.vue?vue&type=style&index=0&id=b493e3da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b493e3da",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ListIcon: require('/builds/marketing/abstracta.academy-website/components/ListIcon.vue').default})
